import axiosConfig from "./axiosConfig";

const BASE = "/accounts/referrals/admin";

export const fetchInviteOverview = (params = {}) =>
  axiosConfig.get(`${BASE}/overview/`, { params });

export const fetchInviters = (params = {}) =>
  axiosConfig.get(`${BASE}/inviters/`, { params });

export const fetchInvites = (params = {}) =>
  axiosConfig.get(`${BASE}/invites/`, { params });

export const setCanInvite = ({ hcc_id, profile_id, can_invite }) => {
  const body = { can_invite };
  if (hcc_id) body.hcc_id = hcc_id;
  if (profile_id) body.profile_id = profile_id;
  return axiosConfig.post(`${BASE}/set-can-invite/`, body);
};
